import getStore from 'services/getStore';

export default id => {
  const media = Object.values(getStore().getState().blocks).filter(
    (b: any) => b.type === 'Media'
  ) as any;

  const mediaParent = media.find(m => m.children.find((c: any) => c.id === id));

  return mediaParent || null;
};
